import { LinkNav } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { DBAS_LEVEL } from '../../../../../const/quiz'
import PortalLink from '../../../../shared/portal/PortalLinks/PortalLink'
import KnowledgeBasePreview from '../../shared/KnowledgeBasePreview'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const RETURN_TO_DASHBOARD_LINK_LABEL = `Return to dashboard`

const KNOWLEDGE_BASE_PREVIEW_TITLE = `Knowledge base`

const KNOWLEDGE_BASE_PREVIEW_BODY = `Visit our knowledge base to download practical advice to help you sleep better. Each guide provides a summary of the science in an easy to read format. These guides have been thoroughly researched, and include commentary from experts in sleep science.`

const KNOWLEDGE_BASE_PREVIEW_LINK_LABEL = `Visit the knowledge base`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const actionForLevel = ({ link, level, downloads, knowledgeBaseUrl }) => {
  if (level === DBAS_LEVEL.LOW) {
    return <PortalLink link={link} dataCy="portal-link" />
  }

  return (
    <KnowledgeBasePreview
      dataCy="knowledge-base-preview-list-signup"
      title={KNOWLEDGE_BASE_PREVIEW_TITLE}
      body={KNOWLEDGE_BASE_PREVIEW_BODY}
      link={{ label: KNOWLEDGE_BASE_PREVIEW_LINK_LABEL, url: knowledgeBaseUrl }}
      downloads={downloads}
    />
  )
}

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: [LAYOUT_SPACING.X_LARGE, 2],
  align: LAYOUT_ALIGN.CENTER,
})``

const Footer = styled.div`
  align-self: center;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Action = ({ link, level, downloads, dashboardUrl, knowledgeBaseUrl }) => (
  <Layout>
    {actionForLevel({
      link,
      level,
      downloads,
      knowledgeBaseUrl,
    })}
    <Footer>
      <LinkNav href={dashboardUrl}>{RETURN_TO_DASHBOARD_LINK_LABEL}</LinkNav>
    </Footer>
  </Layout>
)

Action.propTypes = {
  level: PropTypes.string.isRequired,
  link: PropTypes.object.isRequired,
  downloads: PropTypes.arrayOf(PropTypes.object).isRequired,
  dashboardUrl: PropTypes.string.isRequired,
  knowledgeBaseUrl: PropTypes.string.isRequired,
}

export default Action
